import React from "react";
import { ShimmerDiv } from "./ThemedShimmer";

const SectionSkeleton = ({ rows = 2 }) => (
  <div className="UpdateProfile mb-3 p-3">
    <div className="d-flex justify-content-between mb-3 border-custom pb-2">
      <ShimmerDiv height={24} width={180} rounded={4} />
      <ShimmerDiv height={24} width={24} rounded={4} />
    </div>
    {Array.from({ length: rows }, (_, index) => (
      <ShimmerDiv
        key={`resume-section-row-${index}`}
        className="mb-3"
        height={72}
        width="100%"
        rounded={8}
      />
    ))}
  </div>
);

const ManageResumeSkeleton = ({ className = "" }) => (
  <div
    className={className}
    role="status"
    aria-busy="true"
    aria-label="Loading resume"
  >
    <span className="skeleton-screen-reader-only">Loading resume</span>
    <div className="UpdateProfile mb-3 p-3">
      <div className="d-flex justify-content-between mb-3 border-custom pb-2">
        <ShimmerDiv height={24} width={240} rounded={4} />
        <div className="d-flex align-items-center gap-2">
          <ShimmerDiv height={24} width={40} rounded={4} />
          <ShimmerDiv height={24} width={24} rounded={4} />
          <ShimmerDiv height={24} width={24} rounded={4} />
        </div>
      </div>
      <div className="row border-custom">
        {Array.from({ length: 6 }, (_, index) => (
          <div className="col-md-6 border-custom p-2" key={`resume-field-${index}`}>
            <ShimmerDiv height={16} width={80} rounded={4} className="mb-2" />
            <ShimmerDiv height={20} width="70%" rounded={4} />
          </div>
        ))}
      </div>
      <ShimmerDiv className="mt-3" height={60} width="100%" rounded={8} />
    </div>
    <SectionSkeleton rows={2} />
    <SectionSkeleton rows={2} />
    <SectionSkeleton rows={1} />
    <SectionSkeleton rows={1} />
    <SectionSkeleton rows={2} />
    <SectionSkeleton rows={1} />
  </div>
);

export default ManageResumeSkeleton;
